import SpringConfigs from 'utils/constants/swarm/spring-configs';

export const assignPageUrls = () => {
  for (const pageKey in SpringConfigs.PAGE_URLS) {
    if (SpringConfigs.PAGE_URLS[pageKey] === window.location.origin) {
      Object.assign(SpringConfigs.PAGE_URLS, { homepageKey: pageKey });
      break;
    }
  }
};
